
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Vashitopunecab() {



    const cardData =
    {
        keyword: ' Vashi to Pune Cab',
        heading: 'Skyline Cabs: Vashi to Pune Cab',
        headingDescription: 'Skyline Cabs offers dependable and convenient Vashi to Pune Cab service for a smooth and comfortable intercity journey. Whether you are traveling for work, visiting family, or heading out for a weekend trip, our fleet of clean, well-maintained cars and experienced drivers ensure a safe and relaxing ride. With punctual pickups from Vashi, transparent fares, and 24/7 customer support, Skyline Cabs is your trusted travel partner. Book your Vashi to Pune cab today and enjoy a hassle-free travel experience.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
  {
    "name": "Vashi to Pune Cab",
    "description": "Skyline Cabs offers reliable and comfortable cab services from Vashi to Pune. Whether you're planning a solo trip or traveling with family, our fleet includes sedans, SUVs, and luxury cars to make your journey seamless and enjoyable."
  },
  {
    "name": "Vashi to Pune Taxi Fare",
    "description": "Get the most affordable and transparent taxi fare from Vashi to Pune with Skyline Cabs. We provide upfront pricing with no hidden charges, and our professional service ensures a smooth ride to your destination."
  },
  {
    "name": "Vashi to Pune Taxi Service",
    "description": "Skyline Cabs offers premium taxi services from Vashi to Pune, with 24/7 availability and professional drivers. Book online or by phone, and enjoy a hassle-free ride in our clean, air-conditioned vehicles."
  },
  {
    "name": "Vashi to Pune One Day Cab",
    "description": "Planning a one-day trip from Vashi to Pune? Skyline Cabs provides special one-day cab packages at affordable rates, ideal for quick business meetings, family visits, or a short getaway."
  },
  {
    "name": "Vashi to Pune Round Trip Cab",
    "description": "Book a round trip cab from Vashi to Pune with Skyline Cabs for convenience and value. Enjoy flexibility in scheduling your return and travel comfortably with professional drivers in clean and safe vehicles."
  },
  {
    "name": "Vashi to Pune Ertiga Cab",
    "description": "Skyline Cabs offers Ertiga cabs for group or family travel from Vashi to Pune. Enjoy ample space and comfort with our well-maintained Ertiga vehicles, perfect for long-distance road trips."
  },
  {
    "name": "Vashi to Pimpri Chinchwad Cab",
    "description": "Need to travel from Vashi to Pimpri Chinchwad? Skyline Cabs offers direct cab services with flexible pickup times, competitive pricing, and vehicle options to suit your travel needs."
  },
  {
    "name": "Vashi to Wanowrie Cab",
    "description": "Skyline Cabs provides convenient and comfortable cab rides from Vashi to Wanowrie, Pune. Enjoy a relaxed and punctual journey with our experienced drivers and well-equipped vehicles."
  },
  {
    "name": "Vashi to Pune Sedan Cab",
    "description": "Choose Skyline Cabs' sedan service from Vashi to Pune for a smooth and stylish ride. Perfect for individuals or couples, our sedans offer comfort, affordability, and top-notch service."
  },
  {
    "name": "Vashi to Pune Innova Crysta",
    "description": "Travel in luxury with our Innova Crysta taxi service from Vashi to Pune. Ideal for groups or family trips, our Crysta vehicles provide top-tier comfort, space, and reliability."
  },
  {
    "name": "Vashi to Aundh Cab",
    "description": "Book a cab from Vashi to Aundh, Pune, with Skyline Cabs. We provide efficient service, competitive rates, and a variety of vehicle options for a safe and smooth travel experience."
  },
  {
    "name": "Cab Service in Vashi",
    "description": "Skyline Cabs provides dependable local and outstation cab services in Vashi. Whether you're heading to Pune, Mumbai Airport, or nearby towns, we ensure comfort, safety, and affordability."
  },
  {
    "name": "Vashi to Pune Station Cabs Service",
    "description": "Skyline Cabs offers direct and timely cab services from Vashi to Pune Station. With real-time tracking and courteous drivers, we make sure you reach the station comfortably and on time."
  },
  {
    "name": "Taxi Service in Navi Mumbai",
    "description": "Skyline Cabs is your trusted provider for taxi services in Navi Mumbai. From short local rides to long outstation trips, we offer 24/7 service with well-maintained vehicles and experienced drivers."
  },
  {
    "name": "Outstation Cab Booking in Vashi",
    "description": "Need an outstation cab from Vashi? Skyline Cabs makes it easy to book rides to Pune, Lonavala, Nashik, and beyond. Our wide fleet and reliable service ensure a pleasant travel experience."
  }
],
"tableData": [
  ["Vashi to Pune Cab", "Vashi to Pune Taxi Fare"],
  ["Vashi to Pune Taxi Service", "Vashi to Pune One Day Cab"],
  ["Vashi to Pune Round Trip Cab", "Vashi to Pune Ertiga Cab"],
  ["Vashi to Pimpri Chinchwad Cab", "Vashi to Wanowrie Cab"],
  ["Vashi to Pune Sedan Cab", "Vashi to Pune Innova Crysta"],
  ["Vashi to Aundh Cab", "Cab Service in Vashi"],
  ["Vashi to Pune Station Cabs Service", "Taxi Service in Navi Mumbai"],
  ["Outstation Cab Booking in Vashi", "Cab Service in Vashi"]
],



whychoose: [
    {
        "WhyChooseheading": "Reliable Vashi to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers reliable and on-time cab services for your journey from Vashi to Pune. Whether it's a business trip, personal travel, or an urgent ride, we ensure a smooth and timely travel experience."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Travel in style and comfort with our fleet of clean, air-conditioned sedans, SUVs, and luxury cars. Every vehicle is regularly serviced and equipped to make your Vashi to Pune journey relaxing and pleasant."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our trained and experienced drivers are well-acquainted with the Vashi to Pune route. They prioritize your safety and ensure a smooth, hassle-free ride with courteous service throughout."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Enjoy competitive, fixed-rate cab fares with no hidden charges. Skyline Cabs ensures you receive top-quality service at affordable and transparent prices for your Vashi to Pune trip."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Need to travel late at night or early in the morning? No worries—Skyline Cabs operates 24/7. Book your cab from Vashi to Pune at any hour with our always-available service."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Instant Confirmation",
        "WhyChoosedescription": "Book your Vashi to Pune cab quickly through our website or mobile app. Enjoy instant confirmations and real-time tracking to stay updated on your ride status."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Vehicles",
        "WhyChoosedescription": "We prioritize hygiene and safety. All cabs are sanitized after every trip, and our drivers follow strict safety protocols—ensuring a secure journey every time."
    },
    {
        "WhyChooseheading": "Flexible Vehicle Options to Suit Every Traveler",
        "WhyChoosedescription": "Traveling alone, with family, or in a group? Choose from a range of vehicle options tailored to your needs—from compact sedans to spacious SUVs and premium rides."
    }
]



























    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Vashi to Pune with Skyline Cabs?',
            answer:
                'Booking a cab from Vashi to Pune is simple and quick with Skyline Cabs. Use our website, mobile app, or contact our customer support to book your ride. Enter your pickup and drop-off details, select your vehicle, and confirm the booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Vashi to Pune trip?',
            answer:
                'Skyline Cabs offers multiple vehicle options including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. You can pick the vehicle that suits your comfort level and group size.',
        },
        {
            id: 3,
            question: 'How long does it take to travel from Vashi to Pune?',
            answer:
                'The journey from Vashi to Pune typically takes around 3.5 to 5 hours, depending on traffic and road conditions. Our expert drivers ensure the most efficient and safe route.',
        },
        {
            id: 4,
            question: 'Are the cab fares from Vashi to Pune fixed?',
            answer:
                'Yes, Skyline Cabs offers fixed and transparent fares. Your total cost includes tolls, taxes, and driver charges, so there are no surprises at the end of your ride.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab from Vashi to Pune?',
            answer:
                'Absolutely! You can easily book a round-trip cab while making your reservation. Just mention your return details, and we’ll arrange the full journey for you.',
        },
        {
            id: 6,
            question: 'Can I modify or cancel my Vashi to Pune cab booking?',
            answer:
                'Yes, you can modify or cancel your booking anytime through our app, website, or by calling our customer support. We offer flexible options to suit your plans.',
        },
        {
            id: 7,
            question: 'Are the vehicles used for Vashi to Pune trips clean and reliable?',
            answer:
                'Yes, all our vehicles are regularly cleaned and maintained. We ensure a safe, hygienic, and comfortable travel experience for all our passengers.',
        },
        {
            id: 8,
            question: 'What payment methods can I use for my Vashi to Pune cab ride?',
            answer:
                'You can pay via UPI, credit/debit cards, net banking, or in cash at the end of your ride. All online transactions are secure and convenient.',
        },
        {
            id: 9,
            question: 'Do you offer Vashi to Pune cabs for corporate travel?',
            answer:
                'Yes, we provide reliable and professional cab services for corporate clients. Whether it’s a one-time trip or regular travel, we offer tailored solutions for business needs.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Vashi to Pune journey?',
            answer:
                'Skyline Cabs is known for punctual pickups, courteous drivers, well-maintained cars, and transparent pricing. We ensure your journey from Vashi to Pune is smooth and hassle-free.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "Booked a cab from Vashi to Pune with Skyline Cabs. The ride was comfortable and the driver was very professional. Totally worth it!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "My journey from Vashi to Pune was great. The car was clean, and the booking process was very smooth. Will book again!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Vashi to Pune Cab",
  "image": "https://skylinecabs.com/assets/images/vashi-to-pune-cab.jpg",
  "description": "Book Vashi to Pune cab with Skyline Cabs for a smooth, affordable, and comfortable ride. Choose from AC sedans, SUVs, or premium cabs — available 24/7 with professional drivers for one-way or round-trip travel.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7672"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/vashi-to-pune-cab"
  }
};



      
      

    return (
        <div>
<Helmet>
  <title>Vashi to Pune Cab | AC Taxi Booking 24/7 | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Vashi to Pune cab with Skyline Cabs for a smooth, affordable, and comfortable ride. Choose from AC sedans, SUVs, or premium cabs — available 24/7 with professional drivers for one-way or round-trip travel." 
  />
  <meta 
    name="keywords" 
    content="Vashi to Pune Cab, Cab from Vashi to Pune, One-Way Taxi Vashi to Pune, Round Trip Cab Vashi to Pune, AC Cab Vashi to Pune, SUV Taxi Vashi to Pune, Skyline Cabs Vashi to Pune, Online Cab Booking Vashi to Pune, Affordable Taxi Vashi to Pune, 24/7 Cab Vashi to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/72.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Vashitopunecab;